<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import type { NavItem } from '@/modules/admin/stores/admin-nav';

defineProps<{
  navItems: NavItem[];
}>();

const route = useRoute();
const router = useRouter();

const openRoute = (name: string) => {
  router.push({
    name,
  });
};
</script>

<template>
  <div class="nav-list-container">
    <ul class="nav-list">
      <li
        v-for="(item, index) in navItems"
        :key="index"
        :title="item.title"
        class="nav-item"
        :class="{ 'active': route.name === item.routeName }"
        @click="openRoute(item.routeName)"
      >
        <component
          :is="item.icon"
          class="nav-icon"
        />
      </li>
    </ul>
  </div>
</template>

<style scoped>
.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  padding: 10px 20px;
  cursor: pointer;

  &:hover {
    background-color: #d0d0d0;
  }
}

.active .nav-icon {
  color: green;
}

.nav-icon {
  width: 36px;
  height: 36px;
  color: #424242;
}
</style>
